"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _factory = require("./factory");
var _default = exports["default"] = (0, _factory.createTextArea)();
module.exports = exports.default;